// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import RevvLogo from "./RevvLogo";
import RecipientDocTitle from "./RecipientDocTitle";
import RecipientDocHeaderButtons from "./RecipientDocHeaderButtons";
import RecipientDocReaderModeBtn from "./RecipientDocReaderModeBtn";
// import RecipientDocInfoPopup from "./RecipientDocInfoPopup";

class RecipientDocHeader extends Component {
  state = { showHeaderShadow: false };

  componentDidMount() {
    document.addEventListener("scroll", this._headerCSSWhenScroll, true);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this._headerCSSWhenScroll, true);
  }

  _headerCSSWhenScroll = event => {
    if (event && event.target && event.target.scrollTop > 55) {
      if (!this.state.showHeaderShadow) {
        this.setState({ showHeaderShadow: true });
      }
    } else if (this.state.showHeaderShadow) {
      this.setState({ showHeaderShadow: false });
    }
  };

  render() {
    return (
      <Fragment>
        {/* ----------- Shared document "recipient" and "sender" info popup ----------- */}
        {/* ------- Removed below welcome popup --------*/}
        {/* <RecipientDocInfoPopup sharingHash={this.props.sharingHash} /> */}
        <div
          className={`recipientdocheader-container ${
            this.state.showHeaderShadow ? "header-shadow" : ""
          } ${this.props.isRevvToolbarActive ? "active-revvtoolbar" : ""}`}>
          {/* ----------- Revv Logo and Document title section ----------- */}
          <div className="recipientdocheader-left-section">
            <RevvLogo
              linkUrl={`${process.env.REACT_APP_DOMAIN_NAME}?utm_source=sharedlink`}
              documentPageType={this.props.documentPageType}
              sharingHash={this.props.sharingHash}
            />
            <RecipientDocTitle documentTitle={this.props.headerTitle} />
          </div>
          {/* ----------- Notes, Attachments, Download and other action buttons section ----------- */}
          <div className="recipientdocheader-right-section">
            <RecipientDocHeaderButtons
              data-test="recipientdocheaderbuttons"
              isSharedDocument={this.props.isSharedDocument}
              sharingHash={this.props.sharingHash}
              documentPageType={this.props.documentPageType}
            />
          </div>
        </div>
        {/* -------- Reader mode "ON"/"OFF" buttons for mobile devices only ------- */}
        <RecipientDocReaderModeBtn
          readerMode={this.props.readerMode}
          toggleReaderMode={this.props.toggleReaderMode}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const {
    document: { showForm },
    clickedActiveComponentId,
    activeComponentMeta: { componentId },
  } = state.DocumentStore;
  let isRevvToolbarActive = false;
  if (
    props.isSharedDocument &&
    showForm &&
    componentId === clickedActiveComponentId
  ) {
    isRevvToolbarActive = true;
  }
  return { isRevvToolbarActive };
};

export default connect(mapStateToProps, null)(RecipientDocHeader);
